import { Directive, HostListener, ElementRef, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[appPhoneInput]',
  standalone: true,
})
export class PhoneInputDirective implements AfterViewInit {
  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    // Find the input element inside ngx-intl-tel-input
    const input = this.el.nativeElement.querySelector('input');
    if (input) {
      input.addEventListener('keypress', this.handleKeyPress.bind(this));
      input.addEventListener('paste', this.handlePaste.bind(this));
    }
  }

  private handleKeyPress(event: KeyboardEvent): boolean {
    const char = event.key;
    // Allow only digits and navigation keys
    if (
      !/^\d$/.test(char) &&
      !['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight'].includes(char)
    ) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  private handlePaste(event: ClipboardEvent): void {
    event.preventDefault();
    const pastedText = event.clipboardData?.getData('text') || '';
    const digitsOnly = pastedText.replace(/\D/g, '');
    document.execCommand('insertText', false, digitsOnly);
  }
}
